export default {
  index: -1,
  InvhSeq: -1,
  InvdSeq: -1,
  InvdDesc: "",
  InvdQty: 1,
  UnitCode: "",
  InvdPrice: 0,
  InvdTaxA1: 0,
  InvdTaxC1: 0,
  InvdTaxA2: 0,
  InvdTaxC2: 0,
  UnPaid: 0,
  NetAmt: 0,
  TotalAmt: 0,
  TotalPrice: 0,
  SumPaid: 0,
  DeptCode: "",
  InvdBTaxCr1: "",
  InvdBTaxCr2: "",
  InvdBTaxDr: "",
  InvdT1Cr: "",
  InvdT1Dr: "",
  InvdT2Cr: "",
  InvdT2Dr: "",
  InvdTaxT1: "None",
  InvdTaxR1: 0,
  InvdTaxT2: "None",
  InvdTaxR2: 0,
  PfmSeq: null,
  WhtSeq: 0,
  DimList: {
    Dim: [],
  },
};
